/**
 * TanStack Query hooks for `retargeting-pixel`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	retargetingPixelQueryKeys,
	type CreateRetargetingPixelBody,
	type ListRetargetingPixelResponse,
	type RetargetingPixelRow,
} from "./api";

export function useRetargetingPixelList(): UseQueryResult<ListRetargetingPixelResponse, Error> {
	return useQuery({
		queryKey: retargetingPixelQueryKeys.list(),
		queryFn: list,
	});
}

export function useRetargetingPixelCreate(): UseMutationResult<RetargetingPixelRow, Error, CreateRetargetingPixelBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: retargetingPixelQueryKeys.all });
		},
	});
}

export function useRetargetingPixelDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: retargetingPixelQueryKeys.all });
		},
	});
}
